import {SET_USER,} from "../mutations-type";

const User = {
    state: {
        userInfo:null
    },
    mutations: {
        [SET_USER]: (state, name) => {
            state.userInfo = name;
        },
    }
}
export default User;
